import { Navigate } from 'react-router-dom';
import { useAuth } from '@repletoryreach/sdk-auth';
import type { ReactElement, ReactNode } from 'react';
import { BootSplash } from '../components/BootSplash';

export function RequireUnauthed({ children }: { children: ReactNode }): ReactElement {
  const { user, loading } = useAuth();
  if (loading) return <BootSplash />;
  if (user && user.scope === 'platform') return <Navigate to="/" replace />;
  return <>{children}</>;
}
